import { io, Socket } from "socket.io-client";

const sockets: Map<string, Socket> = new Map();

const getSocketUri = () => {
  // In development, connect to backend server directly
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3001";
  }
  // In production, use relative path with base prefix
  // return `${Config.ROUTER_BASENAME}`;
  return "";
};

export const connectSocket = (socketUri: string): Socket => {
  const namespace = getSocketUri();
  const fullUri = `${namespace}${socketUri}`;

  if (!sockets.has(fullUri)) {
    const newSocket = io(fullUri, {
      transports: ["websocket"],
      withCredentials: true,
    });
    sockets.set(fullUri, newSocket);
  }
  return sockets.get(fullUri) as Socket;
};

export const disconnectSocket = (socketUri: string): void => {
  const socket = sockets.get(socketUri);
  if (socket) {
    socket.disconnect();
    sockets.delete(socketUri);
  }
};

/*
 * Resets the socket connection for a given URI.
 *
 * Usage:
 * - Use this when you need to forcefully disconnect and re-establish a socket connection,
 *   such as when starting a new file upload or when the socket state must be refreshed.
 * - This will disconnect and remove any existing socket for the URI, then create and return a new one.
 *
 * @param socketUri - The socket namespace or path to connect to (e.g., "/upload").
 * @returns The newly created Socket instance.
 *
 */
export const resetSocket = (socketUri: string): Socket => {
  const namespace = getSocketUri();
  const fullUri = `${namespace}${socketUri}`;

  // Disconnect and remove existing socket
  const existingSocket = sockets.get(fullUri);
  if (existingSocket) {
    existingSocket.disconnect();
    sockets.delete(fullUri);
  }

  // Create new socket
  const newSocket = io(fullUri, {
    transports: ["websocket"],
    withCredentials: true,
  });
  sockets.set(fullUri, newSocket);
  return newSocket;
};

export const getSocket = (socketUri: string): Socket | null => {
  return sockets.get(socketUri) || null;
};
